export default __webpack_public_path__ + "static/media/myles_melamed.0b7e46c1.gif";